(function(){
    'use strict'

    angular
    .module('app.calendarizaciones')
    .controller('Calendarizaciones', Calendarizaciones);

    Calendarizaciones.$inject = ['$scope', '$animationsSrv', 'CalendarizacionesService', 'TiposPlanillaService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Calendarizaciones($scope, $animationsSrv, CalendarizacionesService, TiposPlanillaService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        
        var diaOffSet = 5;
        var vm = this;

        vm.tiposPlanilla = [];
        vm.tipoPlanilla = {
            mesCierre: -1
        };
        vm.calendarizaciones = [];

        vm.calendarizacion = {
            id: 0,
            tipoPlanillaId: -1
        };

        vm.guardando = true;

        vm.title = 'Calendarizacion';

        vm.fechaInicioOptions = {
            showWeeks: true
          };

        vm.openFechaInicio = function(){
            vm.fechaInicioOpened = !vm.fechaInicioOpened;
        };
        vm.fechaFinalOptions = {
          showWeeks: true
        };
        vm.openFechaFinal= function(){
            vm.fechaFinalOpened = !vm.fechaFinalOpened;
        };

        vm.loadCalendarizacion = function(calendarizacion){
            
            vm.guardando = false;
            console.log(calendarizacion);
            vm.tipoPlanilla.periodoContable = calendarizacion.periodoContable;
            vm.tipoPlanilla.mesCierre = calendarizacion.mesCierre;
            vm.tipoPlanilla.fechaInicio = calendarizacion.fechaInicio;
            vm.tipoPlanilla.fechaFinal = calendarizacion.fechaFinal; 
            vm.tipoPlanilla.estado = calendarizacion.estado;
            vm.tipoPlanilla.numero = calendarizacion.numero;
            vm.calendarizacion.id = calendarizacion.id;
            vm.tipoPlanilla.esUltimaDelMes = calendarizacion.esUltimaDelMes;
            $animationsSrv.scrollToTop();
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.tipoPlanillaChange = function(tipoPlanillaId){
            if(tipoPlanillaId !== -1 && vm.guardando){
                $scope.calendarizacionForm.tipoPlanillaId.$setValidity("different", true);
                vm.tipoPlanilla = vm.tiposPlanilla.find(function(tipo) {
                    return tipo.id == tipoPlanillaId;
                });
                getAll();          
            }
            else{
                if(tipoPlanillaId != null){
                    vm.tipoPlanilla = {mesCierre: -1};
                    vm.calendarizaciones = [];
                    $scope.calendarizacionForm.tipoPlanillaId.$setValidity("different", false);                    
                }
            }
        };

        vm.mesCierreChange = function(){
            var mesCierre = vm.tipoPlanilla.mesCierre;
            var newFechaInicio = vm.tipoPlanilla.fechaInicio;
            var newFechaFinal = vm.tipoPlanilla.fechaFinal;

            if(mesCierre && newFechaInicio && newFechaFinal){

                newFechaInicio.setMonth(mesCierre - 1);
                newFechaFinal.setMonth(mesCierre - 1);
                vm.tipoPlanilla.fechaInicio = moment(newFechaInicio).toDate();
                vm.tipoPlanilla.fechaFinal = moment(newFechaFinal).toDate();

                calcularRangoCalendarizacion();
            }

        };

        vm.periodoContableChange = function(){
            var periodoContable = vm.tipoPlanilla.periodoContable;
            var newFechaInicio = vm.tipoPlanilla.fechaInicio;
            var newFechaFinal = vm.tipoPlanilla.fechaFinal;

            if(periodoContable && !isNaN(periodoContable) && periodoContable.toString().length == 4 
                && newFechaInicio && newFechaFinal){

                newFechaInicio.setYear(periodoContable);
                newFechaFinal.setYear(periodoContable);
                vm.tipoPlanilla.fechaInicio = moment(newFechaInicio).toDate();
                vm.tipoPlanilla.fechaFinal = moment(newFechaFinal).toDate();

                calcularRangoCalendarizacion();
            }

        };

        function calcularRangoCalendarizacion(){
            if(vm.calendarizaciones.length > 0)
            {
                var newFechaInicio = vm.tipoPlanilla.fechaInicio;
                var newFechaFinal = vm.tipoPlanilla.fechaFinal;

                var countCalendarizaciones = vm.calendarizaciones.filter(function(element){
                    return element.mesCierre == vm.tipoPlanilla.mesCierre;
                }).length;

                var diaInicio = 0;
                var diaFinal = 0;

                diaInicio = 1 + (vm.tipoPlanilla.diasPeriodo * countCalendarizaciones);
                diaFinal = vm.tipoPlanilla.diasPeriodo + (vm.tipoPlanilla.diasPeriodo * countCalendarizaciones);

                newFechaInicio.setDate(diaInicio);
                newFechaFinal.setDate(diaFinal);

                vm.tipoPlanilla.fechaInicio = moment(newFechaInicio).toDate();
                vm.tipoPlanilla.fechaFinal = moment(newFechaFinal).toDate();

                //Prediciendo que es la ultima calendarizacion del mes
                if((diaFinal + diaOffSet) >= 30 )
                {
                    vm.tipoPlanilla.esUltimaDelMes = true;
                }
                else{
                    vm.tipoPlanilla.esUltimaDelMes = false;
                }

            }
        };

        vm.limpiar = function(){
            clearCalendarizacionData();
        }

        getTiposPlanilla();

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getAll(){

            var promise = CalendarizacionesService.getAll(UserInfoService.getCompaniaId(), vm.tipoPlanilla.id);

            promise
            .then(function(calendarizaciones){
                calendarizaciones.forEach(calendarizacion => {
                    calendarizacion.fechaInicio = moment(calendarizacion.fechaInicio).toDate();
                    calendarizacion.fechaFinal = moment(calendarizacion.fechaFinal).toDate();
                });
                vm.calendarizaciones = calendarizaciones;
                calcularRangoCalendarizacion();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las Calendarizaciones.');
                        break;
                }
                
            });
        };

        vm.save = function(){

            $scope.submitted = true;

            if(vm.calendarizacion.tipoPlanillaId == -1){
                $scope.calendarizacionForm.tipoPlanillaId.$setValidity("different", false);
            }

            if(vm.tipoPlanilla.fechaInicio > vm.tipoPlanilla.fechaFinal){
                $scope.calendarizacionForm.fechaInicio.$setValidity("rangeDates", false);
            }
            else{
                $scope.calendarizacionForm.fechaInicio.$setValidity("rangeDates", true);
            }

            if($scope.calendarizacionForm.$valid){
                if(vm.calendarizacion.id == 0){
                    vm.tipoPlanilla.tipoPlanillaId = vm.calendarizacion.tipoPlanillaId;
                    saveCalendarizacion();
                }
                else{
                    if($scope.calendarizacionForm.$dirty){
                        updateCalendarizacion();
                    }
                    else{
                        logger.info('No has modificado ningún dato');
                    }
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        function saveCalendarizacion() {
            var promise = CalendarizacionesService.save(vm.tipoPlanilla);
                
            promise
            .then(function(response){
                getAll();
                logger.success('Inicialización creada con éxito.');
                vm.guardando = true;
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un error al crear la inicialización: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un error al crear la inicialización');
                        break;
                }
            }); 
        }

        function updateCalendarizacion() {

            var calendarizacionObject = {
                id: vm.calendarizacion.id,
                periodoContable: vm.tipoPlanilla.periodoContable,
                mesCierre: vm.tipoPlanilla.mesCierre,
                tipoPlanillaId: vm.tipoPlanilla.id,
                fechaInicio: vm.tipoPlanilla.fechaInicio,
                fechaFinal: vm.tipoPlanilla.fechaFinal,
                estado: vm.tipoPlanilla.estado,
                numero: vm.tipoPlanilla.numero,
                esUltimaDelMes: vm.tipoPlanilla.esUltimaDelMes
            };

            var promise = CalendarizacionesService.update(calendarizacionObject);
                
            promise
            .then(function(response){
                getAll();
                logger.success('Inicialización modificada con éxito.');
                vm.guardando = false;
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un error al modificar la inicialización: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar la inicialización');
                        break;
                }
            }); 
        }

        vm.delete = function(calendarizacion){
            var promise = CalendarizacionesService.remove(calendarizacion);
            
            promise
            .then(function(response){
                vm.calendarizaciones = vm.calendarizaciones.filter(function(u) {
                    return u.id !== calendarizacion.id;
                });
                logger.success('Calendarizacion eliminada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar la Calendarizacion');
                        break;
                }
                
            });   
        };

        function clearCalendarizacionData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.tipoPlanilla = {
                mesCierre: -1
            };

            vm.calendarizacion = {
                id: 0,
                tipoPlanillaId: -1
            };

            vm.calendarizaciones = [];

            vm.guardando = true;
            
            // Set back to pristine.
            $scope.calendarizacionForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.calendarizacionForm.$setUntouched();
        }

    }
})();